import { render, staticRenderFns } from "./CreateOrEditProduct.vue?vue&type=template&id=49f571ae&scoped=true&"
import script from "./CreateOrEditProduct.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditProduct.vue?vue&type=style&index=0&id=49f571ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f571ae",
  null
  
)

export default component.exports